export default "__VITE_ASSET__BjDvwJ1s__"